import type { IColumnInfo } from '@dbl/core/dataSource';
import { SortableAfter } from '@dbl/core/chartEditor';
import { type TFieldType } from '@dbl/core/dataSource';

/**
 * Sortable 拖拽区尾部占位项（非完整 IColumnInfo）。
 * 与现网一致使用断言，避免 FieldType 与 SortableAfter 常量不兼容。
 */
export const createSortablePlaceholderTail = (): Partial<IColumnInfo>[] => [
  {
    id: '',
    column_type: SortableAfter.Placeholder as unknown as TFieldType,
  },
  {
    id: '',
    column_type: SortableAfter.ErrorMessage as unknown as TFieldType,
  },
];

/** 业务字段 + 占位尾项；尾部两项不参与 save，仅驱动占位文案与拖拽错误提示 */
export const buildSortableAppendList = (
  columns: IColumnInfo[],
  mapItem: (item: IColumnInfo) => Partial<IColumnInfo>,
): Partial<IColumnInfo>[] => [...columns.map(mapItem), ...createSortablePlaceholderTail()];

